import React from 'react';
import constants from 'constants/index';
import { handleDateTimeOffset } from 'utils/utility_functions/timezone';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { handleRedirection } from 'utils/utils';
import { useHistory } from 'react-router-dom';

export default function CaseItem({ data }) {
  const userContext = useUserDetailsContext();
  const history = useHistory();

  return (
    <div className="border shadow-small p-3 my-2 msg-dtls">
      <div className="my-2 text-break">
        <span className="text-medium">Opened:</span>
        <span className="ms-1">
          {data?.important_dates?.case_created
            ? handleDateTimeOffset(userContext.userDetails.timezone, data.important_dates.case_created, constants.month_date_year_format)
            : 'N/A'}
        </span>
      </div>
      <div className="my-2 text-break">
        <span className="text-medium">Practice Area:</span>
        <span className="ms-1">{data?.case_description?._case_practice_area_ || 'N/A'}</span>
      </div>
      <div
        className="my-2 text-break "
        onClick={() => {
          const route = data?.case_id ? `/cases/${data?.case_id}` : '/cases';
          handleRedirection(history, route);
        }}
      >
        <span className="text-medium">Case:</span>
        <span className="text-primary-dark redirection-link-no-text-transform ms-1">{data?.case_description?.case_name ?? 'N/A'}</span>
      </div>

      <div className="my-2 text-break">
        <span className="text-medium">SOL:</span>
        <span className="ms-1">
          {data?.important_dates?.statute_of_limitations
            ? handleDateTimeOffset(
                userContext.userDetails.timezone,
                data.important_dates.statute_of_limitations,
                constants.month_date_year_format
              )
            : 'N/A'}
        </span>
      </div>

      <div className="my-2 text-break">
        <span className="text-medium">Case Status:</span>
        <span className="ms-1">{data?.status}</span>
      </div>
    </div>
  );
}
